import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { INNER_BOTTOM_SPACE_DESK, colorsPalette } from '../../theme';

const useStyles = (background) =>
  makeStyles((theme: Theme) =>
    createStyles({
      container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: 36,
        paddingBottom: 36,
        background: theme.palette.secondary.dark,
        [theme.breakpoints.up('md')]: {
          paddingTop: 72,
          paddingBottom: 72,
          background:
            background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,
        },
        '&:first-child': {
          marginTop: 76,
        },
      },
      heading: {
        marginBottom: 22,
        [theme.breakpoints.up('md')]: {
          marginBottom: INNER_BOTTOM_SPACE_DESK,
        },
      },
      itemsWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        [theme.breakpoints.up('md')]: {
          flexDirection: 'row',
          flexWrap: 'wrap',
          alignItems: 'flex-start',
          marginRight: -18,
        },
        [theme.breakpoints.between('sm', 'md')]: {
          width: '100%',
        },
      },
      item: {
        width: '343px',
        background: theme.palette.secondary.light,
        boxShadow: `0px 3px 6px ${colorsPalette.black}`,
        borderRadius: '5px',
        overflow: 'hidden',
        marginBottom: '12px',
        [theme.breakpoints.up('md')]: {
          width: 'calc(100%/6 - 20px)',
          marginRight: '18px',
          marginBottom: 0,
          background: 'none',
          boxShadow: 'none',
          borderRadius: 'none',
        },
        [theme.breakpoints.between('sm', 'sm')]: {
          width: '100%',
          marginBottom: 22,
        },
      },
      imgWrapper: {
        position: 'relative',
        width: '100%',
        height: '200px',
        overflow: 'hidden',
        [theme.breakpoints.up('md')]: {
          height: '250px',
          borderRadius: '5px',
          marginBottom: '22px',
        },
        [theme.breakpoints.between('sm', 'md')]: {
          height: '300px',
        },
      },
      itemImg: {
        position: 'absolute',
        [theme.breakpoints.up('md')]: {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        },
      },
      itemContent: {
        padding: '20px 26px',
        [theme.breakpoints.up('md')]: {
          padding: 0,
        },
      },
      itemTitle: {
        fontSize: '20px',
        lineHeight: '25px',
        fontWeight: 'bold',
        marginBottom: '20px',
        [theme.breakpoints.up('md')]: {
          fontSize: '20px',
          lineHeight: '30px',
          marginBottom: '10px',
        },
      },
    }),
  );
export default useStyles;
